import store from '@/store';
import S_base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index(params, pagination = true) {
    const factoryId = store.state.app.factory.id;
    const _params = {
      factory: factoryId,
      ...params,
    };
    return await S_base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'factory_system_class',
      params: _params,
      pagination,
    });
  },
  async show(id) {
    const params = {
      factory: store.state.app.factory.id,
    };
    return await S_base.show({
      modelName: 'factory_system_class',
      modelId: id,
      params,
    });
  },
  async create(data) {
    return await S_base.create({
      parentName: 'factory',
      parentId: store.state.app.factory.id,
      modelName: 'factory_system_class',
      data: data,
    });
  },
  async update(id, data) {
    return await S_base.update({
      modelName: 'factory_system_class',
      modelId: id,
      data: {
        factory: store.state.app.factory.id,
        ...data,
      },
    });
  },
  async batchSequence(data) {
    return await S_base.update({
      parentName: 'factory',
      parentId: store.state.app.factory.id,
      modelName: 'batch/sequence',
      data,
    });
  },
  async delete(id) {
    const params = {
      factory: store.state.app.factory.id,
    };
    return await S_base.delete({
      modelName: 'factory_system_class',
      modelId: id,
      params,
    });
  },
  async enabled(id) {
    return await S_base.update({
      parentName: 'factory_system_class',
      parentId: id,
      modelName: 'enabled',
      data: {
        factory: store.state.app.factory.id,
      },
    });
  },
  async disabled(id) {
    return await S_base.update({
      parentName: 'factory_system_class',
      parentId: id,
      modelName: 'disabled',
      data: {
        factory: store.state.app.factory.id,
      },
    });
  },
  async indexFactory(params, pagination = true) {
    const factoryId = store.state.app.factory.id;
    const _params = {
      factory: factoryId,
      ...params,
    };
    return await S_base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'index/all',
      params: _params,
      pagination,
    });
  },
};
